import ConfirmationDialog from 'tio-ui/components/confirmation-dialog';
import { t } from 'ember-intl';
import type { TOC } from '@ember/component/template-only';

export interface MarkPaidConfirmationModalSignature {
  Element: HTMLElement;
  Args: {
    isOpen: boolean;
    isReceivingContributions?: boolean;
    onClose: () => void;
    onSubmit: () => void | Promise<void>;
  };
}

const MarkPaidConfirmationModal: TOC<MarkPaidConfirmationModalSignature> = <template>
  <ConfirmationDialog
    @isOpen={{@isOpen}}
    @onCancel={{@onClose}}
    @onConfirm={{@onSubmit}}
    @title={{t "common.accounts.mark_paid"}}
    @intent="warning"
    @confirmText={{t "common.accounts.mark_paid"}}
  >
    <p class="font-semibold mb-4">{{t "common.accounts.mark_paid_modal_body" htmlSafe=true}}</p>
    {{#if @isReceivingContributions}}
      <p class="tio-fg-muted">
        {{t "common.accounts.mark_paid_contributions_disclaimer"}}
      </p>
    {{/if}}
  </ConfirmationDialog>
</template>;

export default MarkPaidConfirmationModal;
